export const CoachSupportRatingsTypes = {
  VeryHappy: 'Very happy',
  Happy: 'Happy',
  Neutral: 'Neutral',
  Unhappy: 'Unhappy',
  VeryUnhappy: 'Very unhappy',
};
